import React from 'react'
import { connect } from 'react-redux'
import makeStyles from '@mui/styles/makeStyles'
import { showAlert, removeBandmate } from '../../actions'
import { destroy } from '../../apis'
import { getErrorMessage } from '../../utils'
import Typography from '@mui/material/Typography'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import Avatar from '@mui/material/Avatar'
import { CloseButton, FormDeleteButton } from '../generics'


const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: 30
  },
  title: {
    fontSize: '1.7rem',
    marginBottom: 24,
    marginTop: 24
  },
  bold: {
    fontWeight: 800,
  },
  avatar: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    marginRight: 15
  },
  item: {
    minWidth: 300,
    padding: 12,
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#dfdfdf'
    }
  },
  button: {
    marginTop: 0,
    marginLeft: 24,
    minWidth: 74,
    width: 74,
    height: 36,
    fontSize: '0.8rem'
  }
}))

const LeaveBand = props => {
  const classes = useStyles()
  const { bands, showAlert, artistId, handleClose, removeBandmate } = props

  const leaveBand = band => () => {
    destroy('/bands/' + band.id + '/leave')
      .then(response => {
          removeBandmate(band.id, artistId)
          showAlert('Successfully left ' + band.attributes.name, 'success')
      })
      .catch(error => {
        const message = getErrorMessage(error)
        showAlert(message, 'error')
    })  
  } 

  return (
    <div className={ classes.root }>
      <CloseButton onClick={ handleClose } />

      <Typography className={ classes.title }>
        <span className={ classes.bold }>Leave</span> Band
      </Typography>

      <List>
      { Object.values(bands).map(band => {
          const { name, image, imageDerivatives } = band.attributes
          const imageURL = imageDerivatives.small || image

          return (
            <ListItem key={ band.id } className={ classes.item }>
              <ListItemAvatar>
                <Avatar
                  className={ classes.avatar }
                  alt={ name } 
                  src={ imageURL }
                  variant='rounded' />
              </ListItemAvatar>
              <ListItemText 
                primary={ name }
                primaryTypographyProps={{ noWrap: true }} />
              <FormDeleteButton 
                className={ classes.button } 
                onClick={ leaveBand(band) }>
                LEAVE
              </FormDeleteButton>
            </ListItem>
          )
        })
      }
      </List>
    </div>
  )
}

export default connect(null, { showAlert, removeBandmate })(LeaveBand)


